query ContentPermissionsQuery($accountIds: [String]!, $contentId: ID!) {
  contentPermissions(contentId: $contentId) {
    contentAccess
    subjectsWithEffectiveContentPermissions {
      edges {
        node {
          id
        }
      }
    }
  }
  usersWithContentRestrictions(accountIds: $accountIds, contentId: $contentId) {
    accountId
    profilePicture {
      path
    }
    hasSpaceViewPermission
    restrictingContent {
      id
      hasRestrictions
    }
  }
}
